import { Column as BaseColumn } from '../../../DataTable/index.jsx';


class Column extends BaseColumn {
  sortAscending(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.name < b.name) {
      return 1;
    }
    if (a.name > b.name) {
      return -1;
    }
    return super.sortDescending(a, b);
  }
}

export default Column;

